import { create } from "zustand";

interface RevenueAnalysticEachStoreState {
  accountId: any;
  month: any;
  year: any;
  monthBefore: any;
  setMonthBefore: (monthBefore: any) => void;
  setMonth: (month: any) => void;
  setYear: (year: any) => void;
  setAccountId: (accountId: any) => void;
}

export const useRevenueAnalysticEachStore =
  create<RevenueAnalysticEachStoreState>((set) => ({
    accountId: null,
    month: undefined,
    year: undefined,
    monthBefore: undefined,
    setAccountId: (accountId) => set({ accountId }),
    setMonthBefore: (monthBefore) => set({ monthBefore }),
    setMonth: (month) => set({ month }),
    setYear: (year) => set({ year }),
  }));
